var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('t-header',{attrs:{"is-admin":_vm.isAdmin}}),_c('v-main',[_c('router-view'),_c('google-consent')],1),(!_vm.isAdmin)?_c('t-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }